import React from "react"
import {Link} from "react-router-dom"
import {useModal} from "react-modal-hook"
import moment from "moment"
import {WhiteLabelAppUser} from "../../../resources/whiteLabel"
import {DataTableRow, DataTableCell} from "../../../components/DataTable/DataTable"
import Tag from "../../../components/Tag/Tag"
import {DataTableActionButton, DataTableActionItem} from "../../../components/DataTable/DataTableActionButton"
import {ArchiveManagedSolutionsUserModal} from "./ArchiveManagedSolutionsUserModal"

interface ManagedSolutionsUserRowProps {
	user: WhiteLabelAppUser
	customerId: string | undefined
	onRefresh: () => void
	readOnly?: boolean
}

export function ManagedSolutionsUserRow({user, customerId, onRefresh, readOnly = false}: ManagedSolutionsUserRowProps) {
	const [showArchiveModal, hideArchiveModal] = useModal(() => (
		<ArchiveManagedSolutionsUserModal close={hideArchiveModal} refresh={onRefresh} user={user} />
	))

	const userStatus = user.attributes.status
	const isArchived = userStatus === "Archived"

	const getRoleTheme = (role: string) => {
		if (role === "Owner") return "success"
		if (role === "Admin") return "info"
		if (role === "ReadOnly") return "warning"
		if (role === "Cardholder") return "neutral"
		return "info"
	}

	const getStatusTheme = (status: string) => {
		if (status === "Active") return "success"
		if (status === "Archived") return "neutral"
		if (status === "Disabled") return "error"
		return "info"
	}

	return (
		<DataTableRow>
			<DataTableCell>{user.attributes.externalUserId}</DataTableCell>
			<DataTableCell>{user.attributes.email || "—"}</DataTableCell>
			<DataTableCell>
				<Tag
					size="small"
					variant="filled"
					theme={getRoleTheme(user.attributes.userRole)}
					content={user.attributes.userRole}
				/>
			</DataTableCell>
			<DataTableCell className="data-table-id-cell">
				{customerId ? (
					<Link to={`/customers/${customerId}`} className="id-link data-table-id">
						{customerId}
					</Link>
				) : (
					"—"
				)}
			</DataTableCell>
			<DataTableCell>
				<Tag
					size="small"
					variant="filled"
					theme={getStatusTheme(user.attributes.status)}
					content={user.attributes.status}
				/>
			</DataTableCell>
			<DataTableCell className="data-table-id-cell">
				{user.relationships.applicationForm?.data?.id ? (
					<Link
						to={`/application-forms/${user.relationships.applicationForm.data.id}`}
						className="id-link data-table-id"
					>
						{user.relationships.applicationForm.data.id}
					</Link>
				) : (
					"—"
				)}
			</DataTableCell>
			<DataTableCell>{moment(user.attributes.createdAt).format("L LT")}</DataTableCell>
			{readOnly ? null : !isArchived ? (
				<DataTableActionButton enableActions={true}>
					<DataTableActionItem title="Archive" icon="archive-locker--content" onClick={showArchiveModal} />
				</DataTableActionButton>
			) : (
				<DataTableCell className="small-width" />
			)}
		</DataTableRow>
	)
}
